import type { SVGProps } from "react";
export interface TrainIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TrainIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TrainIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.5 14.127a.62.62 0 0 0-.126.372l.014.127a.6.6 0 0 0 .113.246zm1 .745a.6.6 0 0 0 .112-.246l.014-.127-.014-.126a.6.6 0 0 0-.112-.246zm-7.887-.498a.6.6 0 0 0-.113-.245v.741a.6.6 0 0 0 .113-.244l.012-.127zM7.5 14.129a.62.62 0 0 0-.125.37l.013.127q.03.136.112.244zM20 9.875l.115.006a1.125 1.125 0 0 1 0 2.238l-.114.006H4a1.125 1.125 0 0 1 0-2.25zM9.625 14.499a1.626 1.626 0 0 1-3.242.167l-.008-.167.008-.165A1.626 1.626 0 0 1 8 12.875l.166.009c.82.083 1.459.774 1.459 1.615m8 0a1.625 1.625 0 0 1-3.242.167l-.007-.167.007-.165a1.626 1.626 0 0 1 3.242.165"
      />
      <path
        fill={color}
        d="M18.875 6c0-1.035-.84-1.875-1.875-1.875H7c-1.036 0-1.875.84-1.875 1.875v9c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875zM7.321 19.875h9.359l-.375-.75h-8.61zM21.125 15a4.12 4.12 0 0 1-2.478 3.78l1.36 2.717.045.105a1.126 1.126 0 0 1-2.001 1.002l-.057-.101-.19-.378H6.197l-.19.378-.056.101a1.126 1.126 0 0 1-1.956-1.107l1.358-2.718A4.12 4.12 0 0 1 2.875 15V6A4.125 4.125 0 0 1 7 1.875h10A4.125 4.125 0 0 1 21.125 6z"
      />
    </svg>
  );
}
